module.exports = __webpack_public_path__ + "img/logo-inside-asia.7ce55d57.png";